type ParseAttachmentFilenameOptions = {
  contentDisposition: unknown
  fallbackFilename: string
}

export const parseAttachmentFilename = ({ contentDisposition, fallbackFilename }: ParseAttachmentFilenameOptions): string => {
  if (typeof contentDisposition !== 'string') {
    return fallbackFilename
  }

  const filenameMatch = contentDisposition.match(/filename="(.+)"/)
  return filenameMatch?.[1] || fallbackFilename
}

export const toReadableDownloadError = async (error: unknown): Promise<unknown> => {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return error
  }

  const { response } = error
  if (!response || typeof response !== 'object' || !('data' in response)) {
    return error
  }

  const { data } = response
  if (!(data instanceof Blob)) {
    return error
  }

  try {
    const parsed: unknown = JSON.parse(await data.text())
    if (!parsed || typeof parsed !== 'object' || !('message' in parsed)) {
      return error
    }

    const { message } = parsed
    if (typeof message === 'string') {
      return new Error(message)
    }
  } catch {
    return error
  }

  return error
}
